import { Box, Text, Link, Flex } from "@chakra-ui/react";
import clsx from "clsx";
import { MdsInsertChartRound } from "react-icons-with-materialsymbols/mds";

import { Icon } from "@/design/components/icon";

export const NoDashboard = (): JSX.Element => {
  return (
    <Flex
      className={clsx(
        "w-full h-full",
        "justify-center items-center",
        "flex-col gap-4 bg-white"
      )}
    >
      <Box
        className={clsx(
          "bg-[#fff0e8]",
          "rounded-full p-6 mb-2",
          "flex items-center justify-center"
        )}
      >
        <Icon as={MdsInsertChartRound} size="xl" color="#e54d2f" />
      </Box>

      <Text className="text-lg font-medium text-gray-700">
        Dashboards are available upon request! Simply email us at{" "}
        <Link
          className={clsx("text-orange-500 no-underline", "hover:underline")}
          href="mailto:support@clootrack.com"
        >
          support@clootrack.com
        </Link>
      </Text>

      <Text className="text-lg font-medium text-gray-700">
        with your details, and we'll set it up within 2-3 working days.
      </Text>

      <Text className="text-lg font-medium text-gray-700">
        Automated dashboards are on the way!
      </Text>
    </Flex>
  );
};
